import React, { useEffect, useState } from "react";
import { CssBaseline } from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Signin from "./pages/Signin";
import Dashboard from "./pages/admin/Dashboard";
import { isAuth } from "./actions/auth";
import Category from "./pages/admin/category/Catagories";
import RolePage from "./pages/admin/role/roles";
import StaffPage from "./pages/admin/staff";
import ProductPage from "./pages/admin/product/product";
import CustomerPage from "./pages/customer";
import CustomerOrderPage from "./pages/customer/customerOrder";
import ProductDetailPage from "./pages/admin/product/productDetail";
import OrderDetailPage from "./pages/admin/order/orderDetail";
import CompanySetting from "./pages/admin/setting";
import OrderPage from "./pages/admin/order/index";
import Order from "./pages/admin/order/order";
import InventoryReport from "./pages/report/inventory";
import socketIOClient from "socket.io-client";
import SalesReport from "./pages/report/sales";
import PrintOrderDetailPage from "./pages/admin/order/printOrder";
import AddRole from "./components/forms/addRole";
import OrderProductsFilter from "./pages/report/filterBySkuOrProductName";
import UpdateRole from "./components/forms/updateRole";
import StaffDetailPage from "./components/forms/detailStaff";
import ProfilePage from "./components/profile";
import ActivityLog from "./pages/report/activity-log";
import { SOCKET_API } from "./config";
import Notifications from "./actions/notification";
import ShipmentOrder from "./pages/admin/order/shipmentOrders";
import AdminDashbored from "./pages/superAdmin/dashbored";
import OrganizationPage from "./pages/superAdmin/organization";
import AdminStaffPage from "./pages/superAdmin/staff";
import SuperAdminPage from "./pages/superAdmin/superadmin";
import ShipmentDetailPage from "./pages/admin/order/shipmentDetail";
import Container from "./pages/admin/container/containers";
import CategoryDetailPage from "./pages/admin/category/categoryDetail";
import ContainerReport from "./pages/report/containerFilter";
import PurchaseContainerReport from "./pages/report/containerPurchase";
import RoleDetailPage from "./pages/admin/role/roleDetail";
import PaymentReport from "./pages/report/paymentReport";
import OrganizationDetalPage from "./pages/superAdmin/organizationUsers";
import AdminDetailPage from "./pages/superAdmin/adminDetail";
import PurchaseProductPage from "./pages/admin/purchaseProduct/product";
import PurchaseProductDetailPage from "./pages/admin/purchaseProduct/purchaseProductDetail";
import PurchaseOrdersPage from "./pages/admin/purchaseOrder/purchaseOrders";
import SubscriptionPage from "./pages/superAdmin/subscription";
import SubscriptionDetailPage from "./pages/superAdmin/subscriptionDetail";
import OrganizationSubscriptionPage from "./pages/superAdmin/organizationSubscriptions";
import AlertBanner from "./components/banner";
import Subscriptions from "./pages/admin/subscription";
import OrganizationSubscriptions from "./pages/superAdmin/organizationDetail";
const theme = createTheme({
  palette: {
    primary: {
      main: "rgba(244,151,3,0.8)",
      light: "rgba(183,42,56,0.788)",
      contrastText: "#fff",
    },
    secondary: {
      main: "rgb(20,61,89)",
      light: "#f8324526",
      contrastText: "#fff",
    },
    background: {
      default: "#f4f5fd",
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: "none",
        },
      },
    },
    MuiIconButton: {
      defaultProps: {
        disableRipple: true,
      },
    },
  },
});
const App = () => {
  const [isRead, setIsRead] = useState(localStorage.getItem("order"));
  useEffect(() => {
    const socket = socketIOClient(SOCKET_API);
    socket.on("connection", (data) => {});
    socket.on("orderChanged", (data) => {
      if (data === isAuth()?.id) {
        const storedCount = localStorage.getItem("notificationCount");
        let count = storedCount ? parseInt(storedCount, 10) : 0;
        localStorage.setItem("notificationCount", count + 1);
      }
    });
    socket.on("orderAssigned", (data) => {
      if (data === isAuth()?.id) {
        const storedCount = localStorage.getItem("notificationCount");
        let count = storedCount ? parseInt(storedCount, 10) : 0;
        localStorage.setItem("notificationCount", count + 1);
      }
    });
  }, []);
  const { viewAllNotifications } = Notifications();
  useEffect(() => {
    localStorage.setItem("sentRequest", true);
    fetchNotifications();
  }, []);
  const fetchNotifications = () => {
    viewAllNotifications().then((data) => {
      if (data.err) {
      } else if (data.notifications) {
        const notifications = data.notifications;
        if (notifications.length > 0) {
          const lastNotification = notifications[0];
          if (lastNotification.id !== isRead && lastNotification.unRead) {
            const storedCount = localStorage.getItem("notificationCount");
            let count = storedCount ? parseInt(storedCount, 10) : 0;
            localStorage.setItem("notificationCount", count + 1);
            localStorage.setItem("order", lastNotification.id);
          }
        }
      }
    });
  };

  return (
    <Router>
      <ThemeProvider theme={theme}>
        <Switch>
          <Route
            exact
            path="/"
            render={(props) => {
              return isAuth() ? (
                <Dashboard {...props} />
              ) : (
                <Signin {...props} />
              );
            }}
          />

          <Route path="/roles" component={RolePage} />
          <Route path="/role/:id" component={RoleDetailPage} />

          <Route path="/orders" component={OrderPage} />
          <Route path="/print/:id" component={PrintOrderDetailPage} />
          <Route path="/shipment/:id" component={ShipmentDetailPage} />

          <Route path="/updateRole/:id" component={UpdateRole} />
          <Route path="/staff-detail/:id" component={StaffDetailPage} />
          <Route path="/customer/order/:id" component={CustomerOrderPage} />
          <Route path="/customers" component={CustomerPage} />
          <Route path="/order" component={Order} />
          <Route path="/shipment-order" component={ShipmentOrder} />
          <Route path="/signin/admin" component={Signin} />
          <Route path="/signin" component={Signin} />
          <Route path="/settings" component={CompanySetting} />
          <Route path="/staff" component={Signin} />
          <Route path="/subscriptions" component={Subscriptions} />
          <Route path="/categories/:name" component={CategoryDetailPage} />

          <Route path="/categories" component={Category} />
          <Route path="/containers" component={Container} />

          <Route
            path="/admin/organization/:id"
            component={OrganizationSubscriptions}
          />
          <Route
            path="/admin/organization-users/:id"
            component={OrganizationDetalPage}
          />

          <Route
            path="/admin/organization-subscriptions/:id"
            component={OrganizationSubscriptionPage}
          />
          <Route
            path="/admin/admin-organization/:id"
            component={AdminDetailPage}
          />
          <Route path="/admin/organization" component={OrganizationPage} />
          <Route path="/detail-reports" component={OrderProductsFilter} />
          <Route path="/product/:id" component={ProductDetailPage} />
          <Route path="/orderDetail/:id" component={OrderDetailPage} />
          <Route path="/staffs" component={StaffPage} />
          <Route path="/admin/signup" component={SuperAdminPage} />
          <Route path="/admin/staff" component={AdminStaffPage} />
          <Route path="/products" component={ProductPage} />
          <Route path="/inventory" component={InventoryReport} />
          <Route path="/activity-log" component={ActivityLog} />
          <Route path="/sales-reports" component={SalesReport} />
          <Route path="/container-report" component={ContainerReport} />

          <Route
            path="/purchase-container"
            component={PurchaseContainerReport}
          />
          <Route path="/payment-report" component={PaymentReport} />
          <Route path="/addRol" component={AddRole} />
          <Route path="/admin/profile" component={ProfilePage} />
          <Route path="/admin/subscriptions" component={SubscriptionPage} />
          <Route
            path="/admin/subscription/:id"
            component={SubscriptionDetailPage}
          />
          <Route path="/admin" component={AdminDashbored} />
          <Route path="/profile" component={ProfilePage} />
          <Route path="/purchase-product/:id" component={PurchaseProductPage} />
          <Route path="/purchase-order" component={PurchaseOrdersPage} />
          <Route path="*" component={Dashboard} />
        </Switch>
        <CssBaseline />
      </ThemeProvider>
    </Router>
  );
};

export default App;
